import { h, Component } from 'preact';

import style from './style.less';

import { trackingProvider, trackEvent, INPUT_KEYS, DIMENSION, EVENT } from '@cube/track';
import { injectScripts } from '@cube/script-injector';

/** Creates div for dailymotion js insertion
 */
@trackingProvider({
	[DIMENSION.componentpath]: 'DailymotionJs'
})
export class DailymotionJs extends Component {

	trackPlayVideo = () => {
		this.state.player.getState().then((state) => {
			trackEvent(this.context, {
				[INPUT_KEYS.action]: EVENT.play,
				[DIMENSION.contentid]: state.videoId,
				[DIMENSION.contenttitle]: state.videoTitle,
				[DIMENSION.player]: 'dailymotion',
				[DIMENSION.contentprovider]: 'dailymotion',
				[DIMENSION.contentvendor]: state.videoOwnerScreenname
			});
		});
	};

	trackPlayAd = (e) => {
		this.state.player.getState().then((state) => {
			trackEvent(this.context, {
				[INPUT_KEYS.action]: EVENT.videoadimpression,
				[DIMENSION.contenttitle]: state.adTitle,
				[DIMENSION.contentplayer]: 'dailymotion',
				[DIMENSION.contentvendor]: state.adAdvertiserName
			});
		});
	};

	initPlayer(video) {
		if (video && window.dailymotion && !this.state.hasLoaded) {
			this.setState({ hasLoaded: true });
			window.dailymotion.createPlayer('dailymotionPlayer',{
				video,
				params: {
					syndicationKey: '275975'
				}
			}).then((player => {
				this.setState({ player });

				player.on(window.dailymotion.events.VIDEO_START, () => {
				  this.trackPlayVideo();
				});

				player.on(window.dailymotion.events.AD_START, (e) => {
				  this.trackPlayAd(e);
				});
			}));
		}
	}

	componentWillMount() {
		injectScripts([
			{
				src: 'https://geo.dailymotion.com/player/x2tiw.js'
			}
		]).then(() => {
			this.initPlayer(this.props.id);
		});
	}

	componentDidMount() {
		this.initPlayer(this.props.id);
	}

	shouldComponentUpdate = () => false;

	render({ noWrapper }) {
		if (noWrapper) {
			return (
				<div>
					<div id="dailymotionPlayer" />
				</div>
			);
		}

		return (
			<div class={style.dailymotionWrapper}>
				<div class={style.videoWrapper}>
					<div class={style.iframeWrapper}>
						<div id="dailymotionPlayer" />
					</div>
				</div>
			</div>
		);
	}
}
